export default __webpack_public_path__ + "static/chatsMobile-548100720f1c2caea30e2135418dab1c.png";